"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ICON_TYPES = exports.ICON_TYPE_CLOSE_BUTTON = exports.ICON_TYPE_FORM = exports.ICON_TYPE_EDIT = exports.ICON_TYPE_ELLIPSIS = exports.ICON_TYPE_CHECK_FILLED = exports.ICON_TYPE_DOCUMENT = exports.ICON_TYPE_TOTAL_AUM = exports.ICON_TYPE_PROSPECTS = exports.ICON_TYPE_CLIENTS = exports.ICON_TYPE_ARROW_UP_DOWN = exports.ICON_TYPE_ARROW_RIGHT = exports.ICON_TYPE_ARROW_LEFT = exports.ICON_TYPE_ARROW_UP = exports.ICON_TYPE_ARROW_DOWN = exports.ICON_TYPE_SUCCESS = exports.ICON_TYPE_UNLOCKED = exports.ICON_TYPE_LOCKED = exports.ICON_TYPE_NEXT = exports.ICON_TYPE_PREV = exports.ICON_TYPE_SEARCH = exports.ICON_TYPE_COLUMNS = exports.ICON_TYPE_ACTION = exports.ICON_TYPE_EXIT = exports.ICON_TYPE_PHONE_CALL = exports.ICON_TYPE_SKYPE = exports.ICON_TYPE_ENVELOPE = exports.ICON_TYPE_ENVOLOPE = exports.ICON_TYPE_BELL_FILLED = exports.ICON_TYPE_BELL = exports.ICON_TYPE_LIST = exports.ICON_TYPE_CHART_BAR_VERTICAL = exports.ICON_TYPE_CHART_BAR_HORIZONTAL = exports.ICON_TYPE_CALENDAR = exports.ICON_TYPE_CHART_PIE = exports.ICON_TYPE_CHART_LINE = exports.ICON_TYPE_MINUS_BUTTON = exports.ICON_TYPE_MINUS = exports.ICON_TYPE_PLUS_BUTTON = exports.ICON_TYPE_PLUS = exports.ICON_TYPE_DELAY = exports.ICON_TYPE_LOGIN_CLIENT = exports.ICON_TYPE_LOGIN = exports.ICON_TYPE_MENU = exports.ICON_TYPE_CLOSE = exports.ICON_TYPE_LINKEDIN = exports.ICON_TYPE_FACEBOOK = exports.ICON_TYPE_TWITTER = exports.ICON_TYPE_DROPDOWN = exports.ICON_TYPE_RADIO = exports.ICON_TYPE_ARROW = exports.ICON_TYPE_INFOBOX = exports.ICON_TYPE_ERROR = exports.ICON_TYPE_VERIFIED = exports.ICON_TYPE_TOOLTIP = void 0;
var ICON_TYPE_TOOLTIP = 'questionmark';
exports.ICON_TYPE_TOOLTIP = ICON_TYPE_TOOLTIP;
var ICON_TYPE_VERIFIED = 'verified';
exports.ICON_TYPE_VERIFIED = ICON_TYPE_VERIFIED;
var ICON_TYPE_ERROR = 'error';
exports.ICON_TYPE_ERROR = ICON_TYPE_ERROR;
var ICON_TYPE_INFOBOX = 'infobox';
exports.ICON_TYPE_INFOBOX = ICON_TYPE_INFOBOX;
var ICON_TYPE_ARROW = 'arrow';
exports.ICON_TYPE_ARROW = ICON_TYPE_ARROW;
var ICON_TYPE_RADIO = 'radio';
exports.ICON_TYPE_RADIO = ICON_TYPE_RADIO;
var ICON_TYPE_DROPDOWN = 'dropdown';
exports.ICON_TYPE_DROPDOWN = ICON_TYPE_DROPDOWN;
var ICON_TYPE_TWITTER = 'twitter';
exports.ICON_TYPE_TWITTER = ICON_TYPE_TWITTER;
var ICON_TYPE_FACEBOOK = 'facebook';
exports.ICON_TYPE_FACEBOOK = ICON_TYPE_FACEBOOK;
var ICON_TYPE_LINKEDIN = 'linkedin';
exports.ICON_TYPE_LINKEDIN = ICON_TYPE_LINKEDIN;
var ICON_TYPE_CLOSE = 'close';
exports.ICON_TYPE_CLOSE = ICON_TYPE_CLOSE;
var ICON_TYPE_MENU = 'menu';
exports.ICON_TYPE_MENU = ICON_TYPE_MENU;
var ICON_TYPE_LOGIN = 'login';
exports.ICON_TYPE_LOGIN = ICON_TYPE_LOGIN;
var ICON_TYPE_LOGIN_CLIENT = 'login-client';
exports.ICON_TYPE_LOGIN_CLIENT = ICON_TYPE_LOGIN_CLIENT;
var ICON_TYPE_DELAY = 'delay';
exports.ICON_TYPE_DELAY = ICON_TYPE_DELAY;
var ICON_TYPE_PLUS = 'plus';
exports.ICON_TYPE_PLUS = ICON_TYPE_PLUS;
var ICON_TYPE_PLUS_BUTTON = 'plus-button';
exports.ICON_TYPE_PLUS_BUTTON = ICON_TYPE_PLUS_BUTTON;
var ICON_TYPE_MINUS = 'minus';
exports.ICON_TYPE_MINUS = ICON_TYPE_MINUS;
var ICON_TYPE_MINUS_BUTTON = 'minus-button';
exports.ICON_TYPE_MINUS_BUTTON = ICON_TYPE_MINUS_BUTTON;
var ICON_TYPE_CHART_LINE = 'chart-line';
exports.ICON_TYPE_CHART_LINE = ICON_TYPE_CHART_LINE;
var ICON_TYPE_CHART_PIE = 'chart-pie';
exports.ICON_TYPE_CHART_PIE = ICON_TYPE_CHART_PIE;
var ICON_TYPE_CALENDAR = 'calendar';
exports.ICON_TYPE_CALENDAR = ICON_TYPE_CALENDAR;
var ICON_TYPE_CHART_BAR_HORIZONTAL = 'chart-bar-horizontal';
exports.ICON_TYPE_CHART_BAR_HORIZONTAL = ICON_TYPE_CHART_BAR_HORIZONTAL;
var ICON_TYPE_CHART_BAR_VERTICAL = 'chart-bar-vertical';
exports.ICON_TYPE_CHART_BAR_VERTICAL = ICON_TYPE_CHART_BAR_VERTICAL;
var ICON_TYPE_LIST = 'list';
exports.ICON_TYPE_LIST = ICON_TYPE_LIST;
var ICON_TYPE_BELL = 'bell';
exports.ICON_TYPE_BELL = ICON_TYPE_BELL;
var ICON_TYPE_BELL_FILLED = 'bell-filled';
exports.ICON_TYPE_BELL_FILLED = ICON_TYPE_BELL_FILLED;
var ICON_TYPE_ENVOLOPE = 'envolope';
exports.ICON_TYPE_ENVOLOPE = ICON_TYPE_ENVOLOPE;
var ICON_TYPE_ENVELOPE = 'envelope';
exports.ICON_TYPE_ENVELOPE = ICON_TYPE_ENVELOPE;
var ICON_TYPE_SKYPE = 'skype';
exports.ICON_TYPE_SKYPE = ICON_TYPE_SKYPE;
var ICON_TYPE_PHONE_CALL = 'phone-call';
exports.ICON_TYPE_PHONE_CALL = ICON_TYPE_PHONE_CALL;
var ICON_TYPE_EXIT = 'exit';
exports.ICON_TYPE_EXIT = ICON_TYPE_EXIT;
var ICON_TYPE_ACTION = 'action';
exports.ICON_TYPE_ACTION = ICON_TYPE_ACTION;
var ICON_TYPE_COLUMNS = 'columns';
exports.ICON_TYPE_COLUMNS = ICON_TYPE_COLUMNS;
var ICON_TYPE_SEARCH = 'search';
exports.ICON_TYPE_SEARCH = ICON_TYPE_SEARCH;
var ICON_TYPE_PREV = 'prev';
exports.ICON_TYPE_PREV = ICON_TYPE_PREV;
var ICON_TYPE_NEXT = 'next';
exports.ICON_TYPE_NEXT = ICON_TYPE_NEXT;
var ICON_TYPE_LOCKED = 'locked';
exports.ICON_TYPE_LOCKED = ICON_TYPE_LOCKED;
var ICON_TYPE_UNLOCKED = 'unlocked';
exports.ICON_TYPE_UNLOCKED = ICON_TYPE_UNLOCKED;
var ICON_TYPE_SUCCESS = 'success';
exports.ICON_TYPE_SUCCESS = ICON_TYPE_SUCCESS;
var ICON_TYPE_ARROW_DOWN = 'arrow-down';
exports.ICON_TYPE_ARROW_DOWN = ICON_TYPE_ARROW_DOWN;
var ICON_TYPE_ARROW_UP = 'arrow-up';
exports.ICON_TYPE_ARROW_UP = ICON_TYPE_ARROW_UP;
var ICON_TYPE_ARROW_LEFT = 'arrow-left';
exports.ICON_TYPE_ARROW_LEFT = ICON_TYPE_ARROW_LEFT;
var ICON_TYPE_ARROW_RIGHT = 'arrow-right';
exports.ICON_TYPE_ARROW_RIGHT = ICON_TYPE_ARROW_RIGHT;
var ICON_TYPE_ARROW_UP_DOWN = 'arrow-up-down';
exports.ICON_TYPE_ARROW_UP_DOWN = ICON_TYPE_ARROW_UP_DOWN;
var ICON_TYPE_CLIENTS = 'clients';
exports.ICON_TYPE_CLIENTS = ICON_TYPE_CLIENTS;
var ICON_TYPE_PROSPECTS = 'prospects';
exports.ICON_TYPE_PROSPECTS = ICON_TYPE_PROSPECTS;
var ICON_TYPE_TOTAL_AUM = 'total-aum';
exports.ICON_TYPE_TOTAL_AUM = ICON_TYPE_TOTAL_AUM;
var ICON_TYPE_DOCUMENT = 'document';
exports.ICON_TYPE_DOCUMENT = ICON_TYPE_DOCUMENT;
var ICON_TYPE_CHECK_FILLED = 'check-filled';
exports.ICON_TYPE_CHECK_FILLED = ICON_TYPE_CHECK_FILLED;
var ICON_TYPE_ELLIPSIS = 'ellipsis';
exports.ICON_TYPE_ELLIPSIS = ICON_TYPE_ELLIPSIS;
var ICON_TYPE_EDIT = 'edit';
exports.ICON_TYPE_EDIT = ICON_TYPE_EDIT;
var ICON_TYPE_FORM = 'form';
exports.ICON_TYPE_FORM = ICON_TYPE_FORM;
var ICON_TYPE_CLOSE_BUTTON = 'close-button';
exports.ICON_TYPE_CLOSE_BUTTON = ICON_TYPE_CLOSE_BUTTON;
var ICON_TYPES = [ICON_TYPE_TOOLTIP, ICON_TYPE_VERIFIED, ICON_TYPE_ERROR, ICON_TYPE_INFOBOX, ICON_TYPE_ARROW, ICON_TYPE_RADIO, ICON_TYPE_DROPDOWN, ICON_TYPE_TWITTER, ICON_TYPE_FACEBOOK, ICON_TYPE_LINKEDIN, ICON_TYPE_CLOSE, ICON_TYPE_MENU, ICON_TYPE_LOGIN, ICON_TYPE_LOGIN_CLIENT, ICON_TYPE_DELAY, ICON_TYPE_PLUS, ICON_TYPE_PLUS_BUTTON, ICON_TYPE_MINUS, ICON_TYPE_MINUS_BUTTON, ICON_TYPE_CHART_LINE, ICON_TYPE_CHART_PIE, ICON_TYPE_CHART_BAR_HORIZONTAL, ICON_TYPE_CHART_BAR_VERTICAL, ICON_TYPE_LIST, ICON_TYPE_BELL, ICON_TYPE_BELL_FILLED, ICON_TYPE_ENVOLOPE, ICON_TYPE_ENVELOPE, ICON_TYPE_SKYPE, ICON_TYPE_PHONE_CALL, ICON_TYPE_EXIT, ICON_TYPE_ACTION, ICON_TYPE_COLUMNS, ICON_TYPE_SEARCH, ICON_TYPE_PREV, ICON_TYPE_NEXT, ICON_TYPE_LOCKED, ICON_TYPE_UNLOCKED, ICON_TYPE_SUCCESS, ICON_TYPE_ARROW_DOWN, ICON_TYPE_ARROW_UP, ICON_TYPE_ARROW_LEFT, ICON_TYPE_ARROW_RIGHT, ICON_TYPE_CLIENTS, ICON_TYPE_PROSPECTS, ICON_TYPE_TOTAL_AUM, ICON_TYPE_DOCUMENT, ICON_TYPE_CHECK_FILLED, ICON_TYPE_ELLIPSIS, ICON_TYPE_EDIT, ICON_TYPE_FORM, ICON_TYPE_CLOSE_BUTTON];
exports.ICON_TYPES = ICON_TYPES;